import { UICommand } from "./UICommand";
import { UICommandContext } from "./UICommandContext";


export class UICommandManager<Context extends UICommandContext,Command extends UICommand<Context>>
{
  _commands:Command[] = []
  _keyboardCommands:Command[] = [];

  updateKeyboardCommands()
  {
    this._keyboardCommands = this._commands.filter( c => c.activeKeyboardInputs.length > 0 );
  }

  processKeyboardInput( e:KeyboardEvent, context:Context )
  {
    for ( let i = 0; i < this._keyboardCommands.length; i++ )
    {
      let c = this._keyboardCommands[ i ];

      if ( ! context.evaluateCondition( c.condition ) )
      {
        continue;
      }

      if ( ! context.evaluateCondition( c.inputCondition ) )
      {
        continue;
      }

      for ( let k = 0; k < c.keyboardInputs.length; k++ )
      {
        let keyboardInput = c.keyboardInputs[ k ];

        if ( keyboardInput.matchesKeys( e ) ) 
        {
          c.execute( context )
          return;
        }
      }
    }

  }
}